module.exports = __webpack_public_path__ + "static/media/schoolshoppinglist4.7a6c950a.png";